export default __webpack_public_path__ + "static/AtightlyguardedHimalayansecretDesktop-980de416900ab267585ef1bf72022efb.jpg";